import React, { Component } from "react"
import { Grid } from "@material-ui/core"
import GridWrapper from "../../atoms/GridWrapper"
import RowGrid from "../../atoms/RowGrid"
import styled from "@emotion/styled"
import ContentsCard from "./ContentCard"
import Kathira from "../../../images/mr_katahira.jpg"
import Books from "../../../images/books.jpg"
import Brandscape from "../../../images/brandscape.jpg"
import Camp from "../../../images/2020katahira.jpg"
import Title from "../../atoms/Title"

export default class Home extends Component {
  render() {
    return (
      <GridWrapper style={{ padding: "60px 10px" }}>
        <Grid>
          <Grid style={{ padding: 20 }}>
            <Title fontSize={45}>Contents</Title>
          </Grid>
          <RowGrid>
            <Grid style={{ margin: "10px" }}>
              <ContentsCard
                title={"片平ゼミとは"}
                src={Camp}
                url={"/seminar"}
              />
            </Grid>
            <Grid style={{ margin: "10px" }}>
              <ContentsCard title={"人物紹介"} src={Kathira} url={"/members"} />
            </Grid>
            <Grid style={{ margin: "10px" }}>
              <ContentsCard
                title={"ゼミ活動"}
                src={Brandscape}
                url={"/projects"}
              />
            </Grid>
            <Grid style={{ margin: "10px" }}>
              <ContentsCard title={"選考情報"} src={Books} url={"/selection"} />
            </Grid>
          </RowGrid>
        </Grid>
      </GridWrapper>
    )
  }
}
